import { Component, OnInit } from '@angular/core';
import { DriverService } from '../../driver.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-driver-feedback',
  templateUrl: './driver-feedback.component.html',
  styleUrls: ['./driver-feedback.component.scss']
})
export class DriverFeedbackComponent implements OnInit {
  id: string;
  did: number;

  idandDate: any = {};
  distance: any = {};
  date: Date = new Date();
  g: any;
  h: any;
  isLoad = false;
  p = 1;
  spin: boolean;
  n: number;
  orderDetail: any = [];
  public href = '';
  constructor(
    private http: HttpClient,
    private router: Router,
    private driverService: DriverService,
    private route: ActivatedRoute
  ) {
    this.href = this.router.url;
    this.id = this.href.split('/')[3];
    // tslint:disable-next-line:radix
    this.did = parseInt(this.id);
   }

  ngOnInit() {
    this.getDriverFeedbackHistory();
  }

  getDriverFeedbackHistory() {
    this.driverService.GETDriverFeedack(this.did).subscribe(Response => {
      this.orderDetail = Response;

      console.log('orderDetaillllllllllllllllll', this.orderDetail);
    });
  }
}
